import React from "react";
import { useLanguage } from "../../../../../context/LanguageContext";
import { useAdminOrdersTranslation } from "../../translations";

export const ErrorMessage = ({ title = "Error", error, onBackClick }) => {
    const { language } = useLanguage();
    const { t } = useAdminOrdersTranslation(language);

    return (
        <div className="admin-error-container">
            <h2>{title}</h2>
            <p>{error}</p>
            <button className="back-button" onClick={onBackClick}>
                {t('backToOrders')}
            </button>
        </div>
    );
};
export default ErrorMessage;